import React from 'react'
import PropTypes from 'prop-types'

import { GlobalProvider } from 'Shared/global_context'
import configureStore from 'Shared/configure_store'

import { indexPageReducers } from '../reducers'

import {
  reducerName as CloneLeaguesSessionsReducerName,
  getInitialState as getInitialStateCloneLeaguesSessions,
} from '../reducers/clone_leagues_sessions'
import {
  reducerName as CloneLeaguesSessionsJobsPollerName,
  getInitialState as getInitialStateCloneLeaguesSessionsJobsPoller,
} from '../reducers/clone_leagues_sessions_jobs_poller'
import {
  reducerName as JobsFiltersReducerName,
  getInitialState as getInitialStateJobsFilters,
} from '../reducers/jobs_filters'

import SessionsDashboard from '../components/root/SessionsDashboard'

const CloneLeaguesSessionsIndex = ({
  searchCloneLeaguesSessionsURL,
  newCloneLeaguesSessionURL,
  cloneLeaguesSessions,
  pollCloneLeaguesSessionURL,
  pollSessionsStatusesURL,
  editCloneLeaguesSessionURL,
  pagination,
}) => {

  const state = {
    [CloneLeaguesSessionsReducerName]: getInitialStateCloneLeaguesSessions({
      cloneLeaguesSessions,
      newCloneLeaguesSessionURL,
      pagination,
      searchCloneLeaguesSessionsURL,
      pollSessionsStatusesURL,
      editCloneLeaguesSessionURL,
    }),
    [CloneLeaguesSessionsJobsPollerName]: getInitialStateCloneLeaguesSessionsJobsPoller({
      pollCloneLeaguesSessionURL,
    }),
    [JobsFiltersReducerName]: getInitialStateJobsFilters(),
  }

  const store = configureStore(
    indexPageReducers,
    state,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
  )

  return (
    <GlobalProvider store={store}>
      <SessionsDashboard
        sessions = {cloneLeaguesSessions}
        newCloneLeaguesSessionURL = {newCloneLeaguesSessionURL}
      />
    </GlobalProvider>
  )
}

CloneLeaguesSessionsIndex.propTypes = {
  newCloneLeaguesSessionURL: PropTypes.string.isRequired,
  searchCloneLeaguesSessionsURL: PropTypes.string.isRequired,
  cloneLeaguesSessions: PropTypes.object.isRequired,
  pollCloneLeaguesSessionURL: PropTypes.string.isRequired,
  pollSessionsStatusesURL: PropTypes.string.isRequired,
  editCloneLeaguesSessionURL: PropTypes.string.isRequired,
  pagination: PropTypes.object.isRequired,
}

export default CloneLeaguesSessionsIndex
